import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base/base.component';
import { Teacher } from 'src/app/core/models/teacher';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { TeacherService } from 'src/app/core/services/teacher.service';
import { UploadService } from 'src/app/core/services/upload.service';
import { ChangePassword } from '../../core/models/change-password';
import { UserService } from '../../core/services/user.service';
import { TeacherBankInfo } from '../../core/models/teacherBankInfo';
import { TeacherBankInfoService } from '../../core/services/teacherBankInfo.service';


@Component({
  selector: 'app-teacher-settings',
  templateUrl: './teacher-settings.component.html',
  styleUrls: ['./teacher-settings.component.scss']
})
export class TeacherSettingsComponent extends BaseComponent implements OnInit {

  @ViewChild('passForm', { static: false }) passForm: NgForm;
  @ViewChild('bankForm', { static: false }) bankForm: NgForm;
  
  userFullName: string;
  teacherId: number;
  UserID: number;

  teacher = {} as Teacher;
  tokenValid: boolean;
  isTeacher: string;
  academyToken: string

  changePassword = {} as ChangePassword;
  loading = false;

  file: File = null;


  teacherBankInfo = {} as TeacherBankInfo;
  teacherBankInfos: TeacherBankInfo[];

  p: number = 1;
  nobankData: boolean = true;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private teacherService: TeacherService,
    private userService: UserService,
    private upload: UploadService,
    private teacherBankInfoService: TeacherBankInfoService
    ) { super() }

  ngOnInit(): void {
    this.academyToken = localStorage.getItem('academyToken');
    this.userFullName = localStorage.getItem('userFullName');

    var teachId = localStorage.getItem('teacherId');
    this.teacherId = Number(teachId);

    var userId = localStorage.getItem('userId');
    this.UserID = Number(userId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.loadData();
    debugger
    this.teacherBankInfoService.getTeacherBankInfoById(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        
        this.teacherBankInfos = data.result.returnData;
        if(this.teacherBankInfos.length === 0) {
          this.nobankData = true;
        }
        else {
          this.nobankData = false;
        }
      }
    )
  }

  loadData() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data=>{
        this.teacher = data.teacher.result.returnData;
      });
  }

  viewProfile(id) {
    this.router.navigate(['/teacher-profile/edit', this.teacherId]);
  }

  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }

  viewSettings(id) {
    this.router.navigate(['/teacher-settings/edit', this.teacherId]);
  }

  ViewPayments(id) {
    this.router.navigate(['/teacher-payments/edit', this.teacherId]);
  }

  saveTeacher() {
    this.loading = true;
    debugger
    this.teacher.academyToken = this.academyToken;
    this.baseService.blockStart();
    this.teacherService.save(this.teacher).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (apiData: any) => {
        this.loading = false;
        this.baseService.blockStop();
        if (apiData.result.message.type === 'Success')  {
          this.alertService.success(this.translate.instant('updated'));
          this.teacher = apiData.result.returnData as Teacher;
          localStorage.setItem('userFullName', this.teacher.fullName);
          this.router.navigate(['/home']);
        }
        else if (apiData.result.message.type === 'Error') {
          this.alertService.error(apiData.result.message.log)
        }
        else {
          this.alertService.error(apiData.result.returnData);
        }
      },
      error => {
        this.loading = false;
        this.baseService.blockStop();
        this.alertService.error(this.translate.instant('loginerror'));
      }
    )
  }

  saveTeacherBankInfo() {
    debugger
    this.loading = true;
    this.teacherBankInfo.teacherId = this.teacherId
    this.teacherBankInfoService.registerTeacherBankInfo(this.teacherBankInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (apiData: any) => {
        this.loading = false;
        if (apiData.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('bankupdated'));
          this.teacherBankInfo = {} as TeacherBankInfo
          this.teacherBankInfoService.getTeacherBankInfoById(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.teacherBankInfos = data.result.returnData;
              this.nobankData = false;
            }
          )
        }
        else if (apiData.result.message.type === 'Error') {
          this.alertService.error(apiData.result.message.log)
        }
        else {
          this.alertService.error(apiData.result.returnData);
        }
      },
      error => {
        this.loading = false;
      }
    )
  }


  deleteBankInfo(infoId: number) {
    debugger
    this.loading = true;
    this.teacherBankInfoService.deleteInfo(infoId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.loading = false;
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('bankinfoDeleted'));
          this.teacherBankInfoService.getTeacherBankInfoById(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.teacherBankInfos = data.result.returnData;
              this.nobankData = false;
            }
          )
        }
        else if (data.result.message.type === 'Error') {
          this.alertService.error(data.result.message.log)
        }
      },
      error => {
        this.loading = false;
      }
    )
  }


  changePass() {
    debugger
    this.loading = true;
    this.baseService.blockStart();
    this.changePassword.userId = this.UserID;
    this.changePassword.confirmNewPassword = this.changePassword.newPassword;
    this.userService.changePassword(this.changePassword).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.loading = false;
        this.baseService.blockStop();
        if (data.success === true) {
          this.alertService.success(this.translate.instant('passchange'));
          this.changePassword = {} as ChangePassword;
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      },
      error => {
        this.loading = false;
        this.baseService.blockStop();
        this.alertService.error(error);
      }
    )
  }

  changeInput1(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  changeInput2(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  changeInput3(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  profilePic(event) {
    this.file = event.target.files[0];
    this.upload.upload(this.file).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.teacher.profileImg = data.result.filePath;
    })
  }

  coverPic(event) {
    this.file = event.target.files[0];
    this.upload.upload(this.file).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.teacher.coverImg = data.result.filePath;
    })
  }
}
